import { FC } from 'react'
import { ImageField, LinkField } from '@prismicio/client'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import tw from 'twin.macro'
import { Body, Grid } from '../UI'
import { AppContext } from '../../context/AppContext'
import InlineSvg from 'react-inlinesvg'
import ctaArrow from '../../images/icons/cta-arrow.svg'
import { observer } from 'mobx-react-lite'
import { RichTextFields } from '../../types/prismic'
import { PrismicRichText } from '@prismicio/react'
import { richTextComponents } from '../../utils/richTextComponents'

type Props = {
  header: string
  subhead: RichTextFields
  whitepapers: Array<{
    title: string
    description: string
    pdf: LinkField
    illustration: ImageField
  }>
}

const Whitepapers: FC<Props> = ({ header, subhead, whitepapers }) => {
  return (
    <AppContext.Consumer>
      {({ openWhitepaper }) => {
        return (
          <section
            css={[tw`bg-gb-cream text-gb-blue font-domaine py-10 lg:(py-12)`]}
          >
            <Grid>
              <div tw="col-span-full mb-12 lg:(col-start-1 col-span-full mb-14)">
                {header && (
                  <div tw="col-span-full lg:(col-span-5)">
                    <h2 css={[Body, tw`mb-[15px] lg:mb-[25px]`]}>{header}</h2>
                  </div>
                )}
                <div tw="col-span-full mb-8 lg:(col-start-1 col-span-4 mb-5 pr-6)">
                  <PrismicRichText
                    field={subhead.richText}
                    components={richTextComponents}
                  />
                </div>
              </div>

              <div tw="col-span-full lg:(col-start-1 col-span-full) xl:px-4">
                <ul tw="flex flex-wrap justify-center gap-[40px]">
                  {whitepapers.map((el, index) => (
                    <li
                      tw="flex items-center border-[1px] border-gb-blue rounded-xl w-full p-4 flex-shrink max-w-[400px] lg:(max-w-[unset] w-[calc(50% - 20px)] p-6)"
                      key={`whitepaper-${index}`}
                    >
                      <GatsbyImage
                        image={getImage(el.illustration)}
                        alt=""
                        tw="w-[68px] mr-[18px] lg:(w-[100px] mr-[35px])"
                      />
                      <div>
                        <button
                          onClick={() => {
                            if ('url' in el.pdf) {
                              openWhitepaper(el.pdf.url)
                            }
                          }}
                        >
                          <h3 tw="text-[15px] line-height[20px] text-left lg:(text-[22px] line-height[24px]) underline">
                            {el.title}
                          </h3>
                        </button>
                        <h4 tw="text-[9px] line-height[11px] w-[90%] my-3 lg:(text-[13px] line-height[16px] my-4)">
                          {el.description}
                        </h4>
                        <button
                          onClick={() => {
                            if ('url' in el.pdf) {
                              openWhitepaper(el.pdf.url)
                            }
                          }}
                          tw="bg-gb-cream border border-gb-blue text-gb-blue uppercase px-7 py-2 w-auto text-[8px] font-object letter-spacing[1px] flex justify-center items-center lg:(w-auto px-12 py-4 text-[13px] transition-colors hover:(bg-gb-red text-white border-gb-red))"
                        >
                          Download
                          <InlineSvg
                            src={ctaArrow}
                            tw="w-4 ml-[5px] mt-[-2px] inline lg:w-6"
                          />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Grid>
          </section>
        )
      }}
    </AppContext.Consumer>
  )
}

export default observer(Whitepapers)
